import { render } from "./FishSlot.vue?vue&type=template&id=4b269e96&scoped=true"
import script from "./FishSlot.vue?vue&type=script&lang=js"
export * from "./FishSlot.vue?vue&type=script&lang=js"

import "./FishSlot.vue?vue&type=style&index=0&id=4b269e96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b269e96"]])

export default __exports__